import { FC } from 'react';
import NavLinks, { NavItem } from './NavLinks';
import NavActions from './NavActions';

interface RightColumnNavProps {
  items: NavItem[];
  isActive: (path: string) => boolean;
  onNavigate: (href: string, overlay?: string) => void;
}

const RightColumnNav: FC<RightColumnNavProps> = ({ items, isActive, onNavigate }) => {
  return (
    <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
      <NavLinks items={items} isActive={isActive} onNavigate={onNavigate} />
      <NavActions />
    </div>
  );
};

export default RightColumnNav;
